import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SeasonComponent } from './season.component';
import { SeasonRankingStandingsComponent } from './season-ranking-standings/season-ranking-standings.component';
import { RacesComponent } from './races/races.component';
import { RaceComponent } from './race/race.component';
import { SettingsComponent } from './settings/settings.component';
import { Race$Resolver } from './race/race$.resolver';
import { RaceRankingsComponent } from './race/race-rankings/race-rankings.component';
import { RaceRankingComponent } from './race/race-ranking/race-ranking.component';
import { SeasonRankingsComponent } from './season-rankings/season-rankings.component';
import { Ranking$Resolver } from './rankings/ranking$.resolver';
import { RaceSettingsComponent } from './race/race-settings/race-settings.component';
import { StartNumberChangeToolComponent } from './race/race-settings/start-number-change-tool/start-number-change-tool.component';

const routes: Routes = [
  {
    path: 'season',
    component: SeasonComponent,
    children: [
      { path: 'races', component: RacesComponent },
      {
        path: 'races/:racePlanId',
        component: RaceComponent,
        resolve: {
          race$: Race$Resolver
        },
        children: [{
          path: '',
          redirectTo: 'rankings',
          pathMatch: 'full'
        }, {
          path: 'rankings',
          component: RaceRankingsComponent,
          children: [{
            path: '',
            redirectTo: '100',
            pathMatch: 'full'
          }, {
            path: ':rankingId',
            component: RaceRankingComponent,
            resolve: {
              ranking$: Ranking$Resolver
            }
          }]
        }, {
          path: 'settings',
          component: RaceSettingsComponent,
          children: [{
            path: 'start-number-change-tool',
            component: StartNumberChangeToolComponent
          }]
        }]
      },
      {
        path: 'rankings',
        component: SeasonRankingsComponent,
        children: [{
          path: ':rankingId/standings',
          component: SeasonRankingStandingsComponent,
          resolve: {
            ranking$: Ranking$Resolver
          }
        }]
      },
      { path: 'settings', component: SettingsComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)]
})
export class SeasonRoutingModule {
}
